import React from 'react'

import { PanelStyleContext } from '../../panel/PanelStyleContext'
import Pagination from '../shared/Pagination'

const TableFooter = ({
    filterExpanded,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    pageCount,
    resultsCount,
    pageOptions,
    pageIndex,
    pageSize,
    setPageSize,
}) => (
    <PanelStyleContext.Consumer>
        {panelContext => {
            const backgroundColorClass = panelContext.backgroundColorClass
            return (
                <div
                    className={`tableFooterWrapper ${
                        filterExpanded ? 'is-hidden' : 'is-visible'
                    }`}
                >
                    <Pagination
                        backgroundColorClass={backgroundColorClass}
                        selectDropDownCaratClass={
                            panelContext.selectDropDownCaratClass
                        }
                        gotoPage={gotoPage}
                        previousPage={previousPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        canNextPage={canNextPage}
                        pageCount={pageCount}
                        resultsCount={resultsCount}
                        pageOptions={pageOptions}
                        pageIndex={pageIndex}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </div>
            )
        }}
    </PanelStyleContext.Consumer>
)

export default TableFooter
